import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import PasswordInput from '@/_components/inputs/password-input'
import { Button } from '@/_components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/_components/ui/form'

import { StepSubmitHandler } from '../_types/step'

const passwordStepValidationSchema = z.object({
  password: z
    .string({
      required_error: 'A senha é obrigatória.',
    })
    .trim()
    .min(8, {
      message: 'A senha deve ter no mínimo 8 caracteres.',
    }),
  passwordConfirmation: z
    .string({
      required_error: 'A confirmação da senha é obrigatória.',
    })
    .trim()
    .min(8, {
      message: 'A confirmação da senha deve ter no mínimo 8 caracteres.',
    }),
})

type PasswordStepValidationSchema = z.infer<typeof passwordStepValidationSchema>

export type PasswordStepSubmitHandler =
  StepSubmitHandler<PasswordStepValidationSchema>

interface PasswordStepProps {
  onSubmit: PasswordStepSubmitHandler
}

const PasswordStep = ({ onSubmit }: PasswordStepProps) => {
  const form = useForm<PasswordStepValidationSchema>({
    resolver: zodResolver(passwordStepValidationSchema),
  })

  return (
    <Form {...form}>
      <form
        className="space-y-6"
        onSubmit={form.handleSubmit((data) => onSubmit(data, form.setError))}
      >
        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Nova senha</FormLabel>
              <FormControl>
                <PasswordInput
                  placeholder="Digite a sua nova senha"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="passwordConfirmation"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Confirme a nova senha</FormLabel>
              <FormControl>
                <PasswordInput placeholder="Confirme a nova senha" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button
          type="submit"
          className="w-full"
          disabled={form.formState.isSubmitting}
        >
          Criar senha
        </Button>
      </form>
    </Form>
  )
}

export default PasswordStep
